import './App.css';
import './Styletics.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { NavBar } from "./components/layout/NavBar";
import { Banner } from "./components/layout/Banner";
import { Timeline } from "./components/portfolio/Timeline";
import { Contact } from "./components/portfolio/Contact";
import { RoboticArmChart } from './components/portfolio/RoboticArmChart';
import { HumanoidRobotChart } from './components/portfolio/HumanoidRobotChart';
import { Miro } from './components/features/vector/Miro';
import { Footer } from "./components/layout/Footer";
import FloatingShapes from './components/common/FloatingShapes';
import RouletteEmbed from './components/features/roulette/RouletteEmbed';
import Spa1AnalysisMobile from './components/features/hft/Spa1AnalysisMobile';
import { AgentDashboard } from './components/features/agents/AgentDashboard';
import SkateboardGame from './components/features/skateboard/SkateboardGame';
import InspectResume from './components/features/resume/InspectResume';
import Algorythms from './components/features/algorithms/Algorythms';
import Vocabulary from './components/features/vocabulary/Vocabulary';

function App() {
  return (
    <div className='App'>
      <div className="global-background">
        <FloatingShapes 
          count={8} 
          minSize={40} 
          maxSize={120} 
          minDelay={0} 
          maxDelay={15} 
          minDuration={12} 
          maxDuration={30}
          className="global-floating-shapes"
        />
      </div>
      <Router>
        <Routes>
            
            <Route path='/'
                   element={
                <>
                <NavBar />
                <Banner />  
                {/* <Timeline />          */}
                <Contact />
                <Footer />
                </>
              
              } 
            />
            
            {/* Roulette app redirect route */}
            <Route path='/roulette' element={<Navigate to="https://bled-roulette.netlify.app" replace />} />
            
            {/* Roulette app embedded route (alternative approach) */}
            <Route path='/bled-roulette' element={<RouletteEmbed />} />
            
            {/* HFT Analysis Interactive route */}
            <Route path='/spa1' element={<Spa1AnalysisMobile />} />
            
            {/* Agent Dashboard route */}
            <Route path='/agents' element={<AgentDashboard />} />
            
            {/* Skateboard Game route */}
            <Route path='/skateboarding' element={<SkateboardGame />} />
            
            {/* Inspect Resume route */}
            <Route path='/resume' element={<InspectResume />} />

            {/* Algorithms & Data Structures route */}
            <Route path='/algorythms' element={<Algorythms />} />

            {/* Calculus & Physics Vocabulary route */}
            <Route path='/vocabulary' element={<Vocabulary />} />

            {/* Calculus Chart route */}
            <Route path='/calculus' element={<Timeline />} /> 

            {/* Miro route */}
            <Route path='/miro' element={<Miro />} /> 

            {/* Robots Chart route */}
            <Route path='/robots' element={<><RoboticArmChart /> <HumanoidRobotChart /></>} /> 
        </Routes>
      </Router>
    </div>
  );
}

export default App;
